import { render, staticRenderFns } from "./Waiter.vue?vue&type=template&id=08ea3890&scoped=true&"
import script from "./Waiter.vue?vue&type=script&lang=js&"
export * from "./Waiter.vue?vue&type=script&lang=js&"
import style0 from "./Waiter.vue?vue&type=style&index=0&id=08ea3890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea3890",
  null
  
)

export default component.exports